'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactUtils = require('react-utils');

exports.default = (0, _reactUtils.keyMirror)({
  NOT_MY_JOB: null,
  NO_TIME: null,
  I_DONT_GET_IT: null,
  BACK_SOON: null
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/constants/OnboardingLeaveReasons.js
// module id = 476
// module chunks = 0